// extracted by mini-css-extract-plugin
module.exports = {"container":"mainContent_container__fapf8","mainText":"mainContent_mainText__6qAv0","secondaryText":"mainContent_secondaryText__2yEfo"};